<template>
    <b-navbar toggleable="md" class="custom-navbar" type="dark">
        <b-navbar-toggle target="nav-collapse" class="ml-auto my-2" link-classes="custom-navbar__link"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav v-model="visible">
            <b-navbar-nav>
                <b-nav-item 
					link-classes="custom-navbar__link"
					active-class="custom-navbar__link--active" 
					:to="assignRoute('summary')"
				>
					<span class="fas fa-tachometer-alt"></span> {{ $t('summary') }}
                </b-nav-item>
                <b-nav-item 
				 	v-if="this.$store.state.user.permissions.canViewData"
					link-classes="custom-navbar__link"
					active-class="custom-navbar__link--active" 
					:to="assignRoute('data')"
				>
					<span class="fas fa-database"></span> {{ $t('data') }}
				</b-nav-item>
                <b-nav-item 
					link-classes="custom-navbar__link"
					active-class="custom-navbar__link--active" 
					:to="assignRoute('report')"
				>
					<span class="fas fa-chart-bar"></span> {{ $t('report') }}
				</b-nav-item>
                <b-nav-item 
					link-classes="custom-navbar__link"
					active-class="custom-navbar__link--active" 
					:to="assignRoute('goals')"
				>
					<span class="fas fa-tasks"></span> {{ $t('goals') }}
				</b-nav-item>
                <b-nav-item 
					link-classes="custom-navbar__link"
					active-class="custom-navbar__link--active" 
					:to="assignRoute('documents')"
				>
					<span class="fas fa-copy"></span> {{ $t('documents') }}
				</b-nav-item>
                <b-nav-item 
					link-classes="custom-navbar__link"
					active-class="custom-navbar__link--active" 
					:to="assignRoute('audit')"
				>
					<span class="fas fa-calendar-check"></span> {{ $t('audit') }}
				</b-nav-item>
            </b-navbar-nav>

            <!-- User Menu -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown menu-class="custom-navbar__dropdown" no-flip offset="-10" right no-caret>
                    <template slot="button-content">
                        <span class="text-white">{{ this.$store.state.user.name }}</span>
                        <b-avatar :src="this.$store.state.user.profilePic"></b-avatar>
                    </template>
                    <b-dropdown-item 
						link-class="custom-navbar__dropdown-item" 
						:to="{name: 'user-profile', params: {user_id: this.$store.state.user.id}}"
					>
                        <span>
                            <i class="fas fa-user mr-2"></i>
                            <span class="nav-dropdown-text">{{$t('My Account')}}</span>
                        </span>
                    </b-dropdown-item>
                    <b-dropdown-item 
						v-if="this.$store.state.user.permissions.isAdmin" 
						:to="{name: 'admin-general'}"
						link-class="custom-navbar__dropdown-item" 
					>
                        <span>
                            <i class="fas fa-user-cog mr-2"></i>
                            <span class="nav-dropdown-text">{{$t('Admin Panel')}}</span>
                        </span>
                    </b-dropdown-item>
                    <b-dropdown-item 
						v-if="this.$store.state.user.permissions.isAdmin && this.isMaster(this.$store.state.user.customerId)" 
						:to="{name: 'emission-library'}"
						link-class="custom-navbar__dropdown-item" 
					>
                        <span>
                            <i class="fas fa-user-shield mr-2"></i>
                            <span class="nav-dropdown-text">{{$t('Master Panel')}}</span>
                        </span>
                    </b-dropdown-item>
                    <b-dropdown-item 
						v-if="this.gbId(this.$store.state.user.customerId) || this.isbId(this.$store.state.user.customerId)" 
                        :to="{name: 'library'}"
						link-class="custom-navbar__dropdown-item" 
					>
                        <span>
                            <i class="fas fa-info-circle mr-2"></i>
                            <span class="nav-dropdown-text">{{$t('Library')}}</span>
                        </span>
                    </b-dropdown-item>
                    <b-dropdown-item 
						v-if="this.gbId(this.$store.state.user.customerId)" 
						v-bind:href="'mailto:Verimlilik@garantibbva.com.tr'"
						link-class="custom-navbar__dropdown-item" 
					>
                        <span>
                            <i class="fas fa-envelope mr-2"></i>
                            <span class="nav-dropdown-text">{{$t('contact us')}}</span>
                        </span>
                    </b-dropdown-item>
                    <b-dropdown-item 
						:to="{name: 'login'}" 
						link-class="custom-navbar__dropdown-item" 
						@click.native="logout"
					>
                        <span>
                            <i class="fas fa-sign-out-alt mr-2"></i>
                            <span class="nav-dropdown-text" aria-hidden="true">{{$t('logout')}}</span>
                        </span>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>

<script>
import _ from 'lodash';
import '@/assets/scss/components/_navbar.scss';

export default {
	name: 'TheNavbar',
	data() {
		return {
			visible: null
		}
	},
	watch: {
		visible(val) {
			this.$emit('change', val);
		}
	},
	methods: {
        assignRoute(page) {

            switch (page) {
                case 'summary':
                    return this.$store.state.siteId ? {name: 'dashboard', query: {year: this.year, site_id: this.$store.state.siteId}} : {name: 'dashboard', query: {year: this.year}};
                case 'data':
                    return this.$store.state.siteId ? {name: 'site-data-types', params: {site_id: this.$store.state.siteId}, query: {type: 'consumption',year: this.year}} : {name: 'data-sites'};
                case 'report':
                    return this.$store.state.siteId ? {name: 'general-analysis', params:{site_id: this.$store.state.siteId}, query: {year: this.year}} : {name: 'analysis'};
                case 'goals':
                    return this.$store.state.siteId ? {name: 'goal-detail', params:{site_id: this.$store.state.siteId}} : {name: 'goal'};
                case 'documents':
                    return this.$store.state.siteId ? {name: 'site-files', params: {site_id: this.$store.state.siteId}, query:{year: this.year}} : {name: 'doc'};
                case 'audit':
                    if(this.isUserAssingedToAnySite()) {
                        return {name: 'audit'};
                    } else if(this.$store.state.siteId) {
                        return {name: 'Detail', params: {site_id: this.$store.state.siteId}, query: {year: this.year}};
                    } else {
                        return {name: 'Summary'};
                    }
            
                default:
                    break;

            }
        },
		isUserAssingedToAnySite() {
            return (this.gbId(this.$store.state.user.customerId) && _.get(this.$store.state.user.assignedSites,'length') > 0);
        },
		logout() {
            let store = this.$store;
            return this.axios.post('logout').then(() => {
                this.getInitialState(store.state);
                localStorage.removeItem('token');
            });
        }
	}
};
</script>

<i18n>
    {
        "tr": {
            "summary": "Özet",
            "data" : "Veri",
            "report" : "Analiz",
            "goals" : "Hedefler",
            "documents" : "Dokümanlar",
            "audit" : "Denetim",
            "My Account": "Hesabım",
            "Admin Panel": "Admin Paneli",
            "Settings": "Ayarlar",
            "Library": "Kütüphane",
            "contact us": "Bize ulaşın",
            "logout" : "Çıkış"
    },
        "en": {
            "summary": "Summary",
            "data" : "Data",
            "report" : "Analysis",
            "goals" : "Targets",
            "documents" : "Documents",
            "audit" : "Audits",
            "My Account": "My Account",
            "Admin Panel": "Admin Panel",
            "Settings": "Settings",
            "Library": "Library",
            "contact us": "Contact us",
            "logout" : "Log out"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/TheNavbar.vue